export default __webpack_public_path__ + "static/og-05129ae6535def0725b977dc7defd9ac.jpg";